export default __webpack_public_path__ + "static/graphic-car-loans-5334afa13f4d9480ffd66c22727a810c.svg";